// extracted by mini-css-extract-plugin
module.exports = {"checkboxesContainer":"CreateEditClinics_checkboxesContainer__BNkVM","emails":"CreateEditClinics_emails__3EKz1","emailTagLabel":"CreateEditClinics_emailTagLabel__3oqEi"};